/**
 * Friendly "adjective + animal" nicknames for guests, so kids never face an
 * empty name box. Shared because the server names guest-pool bots the same way.
 * Every combination stays within the 20-character name limit.
 */
export type NameLocale = 'tr' | 'en';

const WORDS: Record<NameLocale, { adjectives: string[]; animals: string[] }> = {
  tr: {
    adjectives: ['Neşeli', 'Cesur', 'Hızlı', 'Akıllı', 'Minik', 'Şirin', 'Sevimli', 'Kurnaz', 'Uykucu', 'Meraklı', 'Komik', 'Parlak'],
    animals: ['Panda', 'Tavşan', 'Kedi', 'Penguen', 'Zürafa', 'Kirpi', 'Sincap', 'Yunus', 'Aslan', 'Fil', 'Koala', 'Ördek'],
  },
  en: {
    adjectives: ['Happy', 'Brave', 'Speedy', 'Clever', 'Tiny', 'Sunny', 'Sneaky', 'Sleepy', 'Curious', 'Funny', 'Shiny', 'Jolly'],
    animals: ['Panda', 'Bunny', 'Kitten', 'Penguin', 'Giraffe', 'Hedgehog', 'Squirrel', 'Dolphin', 'Lion', 'Elephant', 'Koala', 'Duck'],
  },
};

const pick = <T,>(list: readonly T[], random: () => number): T => list[Math.floor(random() * list.length)];

/** A random nickname such as "Neşeli Panda"; never returns `avoid` (used by the reroll button). */
export function randomName(locale: NameLocale, random: () => number = Math.random, avoid?: string): string {
  const { adjectives, animals } = WORDS[locale];
  for (let i = 0; i < 10; i++) {
    const name = `${pick(adjectives, random)} ${pick(animals, random)}`;
    if (name !== avoid) return name;
  }
  return `${adjectives[0]} ${animals[0]}`;
}

export const NAME_WORDS = WORDS;
